<button
  matButton
  [disabled]="!enabled() || isSaving || isSuccess"
  cdkFocusInitial
  [class.pulse]="isSuccess"
>
  <mat-icon [class.spinning]="isSaving">
    {{ isSuccess ? 'check' : isSaving ? 'autorenew' : 'save' }}
  </mat-icon>
  {{ buttonLabel }}
</button>
